"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const enum_1 = require("./enum");
const moment_1 = tslib_1.__importDefault(require("moment"));
const moment_parseformat_1 = tslib_1.__importDefault(require("moment-parseformat"));
moment_1.default.parseFormat = moment_parseformat_1.default;
function isEmpty(obj) {
    if (!obj) {
        return true;
    }
    for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }
    return JSON.stringify(obj) === JSON.stringify({});
}
exports.isEmpty = isEmpty;
function csvToJson(csv) {
    const lines = csv.split("\n").map(line => line.trim()).filter(line => line);
    if (lines.length === 0)
        return [];
    const headers = lines[0].split(",").map(header => header.trim());
    console.log(headers);
    const result = [];
    function inferType(value) {
        if (value == null || value === "" || value.toLowerCase() === "null")
            return null; // Treat empty & "null" as null
        if (!isNaN(value) && value.trim() !== "") {
            let num = Number(value);
            return Number.isInteger(num) ? num : parseFloat(num.toFixed(6)); // Fix precision for floats
        }
        return value; // Otherwise, keep it as a string
    }
    for (let i = 1; i < lines.length; i++) {
        const currentline = lines[i].split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/) || [];
        const obj = {};
        headers.forEach((header, j) => {
            let value = currentline[j] ? currentline[j].trim() : null;
            // Remove surrounding quotes if present
            if (value && value.startsWith('"') && value.endsWith('"')) {
                value = value.slice(1, -1);
            }
            obj[header] = inferType(value); // Infer the type dynamically
        });
        result.push(obj);
    }
    return result;
}
exports.csvToJson = csvToJson;
;
function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}
exports.isFunction = isFunction;
;
function getModule(url) {
    if (!url.match("/daily-update") && !url.match("/cash-flow") && !url.match("/corporate") && !url.match("/buyer") && !url.match("/settings") && !url.match("/dashboard") && !url.match("/map-data") && !url.match("/alltasks"))
        return enum_1.MODULE.SMART_FARM;
    else if (url.match("/cash-flow"))
        return enum_1.MODULE.CASH_FLOW;
    else if (url.match("/daily-update") || url.match("/alltasks"))
        return enum_1.MODULE.DAILY_UPDATE;
    else if (url.match("/map-data"))
        return enum_1.MODULE.MAP_DATA;
    else if (url.match("/settings"))
        return enum_1.MODULE.SETTINGS;
    else if (url.match("/dashboard"))
        return enum_1.MODULE.DASHBOARD;
    else if (url.match("/corporate"))
        return enum_1.MODULE.CORPORATE;
    else if (url.match("/buyer"))
        return enum_1.MODULE.BUYER_PROFILE;
    else if (url.match("/reports"))
        return enum_1.MODULE.REPORT;
}
exports.getModule = getModule;
function goToHomePage(history, isFromHome) {
    if (!isFromHome) {
        history.push('/home');
    }
}
exports.goToHomePage = goToHomePage;
function getRelativePath(url) {
    if (url) {
        const urlObj = new URL(url);
        return urlObj.pathname.replace(/^\/+/, "");
    }
}
exports.getRelativePath = getRelativePath;
exports.detectDateTimeColumns = (data) => {
    if (!data || data.length === 0)
        return [];
    const sampleSize = Math.min(20, data.length);
    const columns = Object.keys(data[0]);
    const dateFormats = [
        moment_1.default.ISO_8601,
        "MM/DD/YYYY HH:mm",
        "M/D/YYYY H:mm",
        "YYYY-MM-DD HH:mm:ss",
        "YYYY/MM/DD HH:mm",
        "DD-MM-YYYY HH:mm",
        "YYYY-MM-DD",
        "MM/DD/YYYY",
        "HH:mm",
        "HH:mm:ss"
    ];
    return columns.filter(col => {
        const samples = data.slice(0, sampleSize).map(row => row[col]);
        let dateLikeCount = 0;
        samples.forEach(value => {
            if (value == null || value === '')
                return;
            const strValue = String(value).trim();
            if (/^\d+$/.test(strValue) && !strValue.includes(':')) {
                return;
            }
            if (/^\d+:\d{2}(:\d{2})?$/.test(strValue)) {
                dateLikeCount++;
                return;
            }
            const isValidDate = dateFormats.some(format => moment_1.default(strValue, format, true).isValid());
            if (isValidDate) {
                dateLikeCount++;
            }
        });
        return dateLikeCount / samples.length > 0.6;
    });
};
//# sourceMappingURL=Utils.js.map